export function parseDecimal(value) {
  const valueAsString = String(value)
  return parseInt(valueAsString, 10)
}
